<template>
  <v-hover>
    <v-card
      :to="'/project/' + project.uri"
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 0}`"
      :color="hover ? 'white' : 'transparent' "
    >
      <!-- <a :href="> -->
        <v-img
          :src="project.imageThumbnail"
          aspect-ratio="1.6"
        >
          <v-container fill-height fluid text-right class="py-2 px-0">
            <v-layout justify-end>
              <v-flex xs4>
                <v-chip justify-end class="no-decoration elevation-10 project-type" color="white">
                  <span v-if="project.projectType === 'idea'"> 💡</span>
                  <span v-if="project.projectType === 'prototype'"> 💎</span>
                  <span v-if="project.projectType === 'pilot'"> 🚀</span>
                </v-chip>
              </v-flex>
            </v-layout>
          </v-container>
        </v-img>
      <!-- </a> -->
      <v-card-title primary-title>
        <div class="text-xs-left">
          <h3>{{project.title}}</h3>
          <p>
            {{project.description}}
          </p>
        </div>
      </v-card-title>

      <!-- <v-card-actions>
        <v-btn flat color="green" :to="'/project/' + project.uri">Explore</v-btn>
      </v-card-actions> -->
    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'projectCard',
  props: {
    project: {
      type: Object,
      required: true
    }
  }
}
</script>
